import { genreOptions, regionOptions, yearOptions } from '@/mocks/categories';

export interface FilterState {
  genre: string;
  region: string;
  year: string;
}

interface FilterPanelProps {
  filters: FilterState;
  onChange: (next: FilterState) => void;
  onReset: () => void;
  showReset: boolean;
}

const ALL = '全部';

function FilterGroup({
  title,
  options,
  value,
  onSelect,
}: {
  title: string;
  options: string[];
  value: string;
  onSelect: (value: string) => void;
}) {
  return (
    <div className="border-b border-background-200 pb-5 last:border-0 last:pb-0">
      <h3 className="mb-3 font-heading text-sm font-bold text-foreground-900">{title}</h3>
      <div className="flex flex-wrap gap-2">
        {[ALL, ...options].map((option) => {
          const active = value === option || (option === ALL && !value);
          return (
            <button
              key={option}
              type="button"
              onClick={() => onSelect(option === ALL ? '' : option)}
              className={`cursor-pointer whitespace-nowrap rounded-full px-3 py-1 text-xs transition-colors ${
                active
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-100 text-foreground-600 hover:bg-secondary-100 hover:text-secondary-800'
              }`}
            >
              {option}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default function FilterPanel({ filters, onChange, onReset, showReset }: FilterPanelProps) {
  return (
    <div className="flex flex-col gap-5 rounded-lg border border-background-200 bg-background-50 p-5">
      <div className="flex items-center justify-between">
        <h2 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
          <i className="ri-filter-3-line text-primary-500" />
          筛选条件
        </h2>
        {showReset && (
          <button
            type="button"
            onClick={onReset}
            className="cursor-pointer whitespace-nowrap text-xs text-accent-600 transition-colors hover:text-accent-700"
          >
            重置
          </button>
        )}
      </div>

      <FilterGroup
        title="类型"
        options={genreOptions}
        value={filters.genre}
        onSelect={(genre) => onChange({ ...filters, genre })}
      />
      <FilterGroup
        title="地区"
        options={regionOptions}
        value={filters.region}
        onSelect={(region) => onChange({ ...filters, region })}
      />
      <FilterGroup
        title="年份"
        options={yearOptions}
        value={filters.year}
        onSelect={(year) => onChange({ ...filters, year })}
      />
    </div>
  );
}